(function() {
    const ATTR = {
        FIRST_SOURCE: 'attr_first_source',
        FIRST_CAMPAIGN: 'attr_first_campaign',
        LAST_SOURCE: 'attr_last_source',
        LAST_CAMPAIGN: 'attr_last_campaign',
        FULL_JOURNEY: 'attr_utm_journey',
        FIRST_TOUCH: 'attr_first_touch',
        LAST_TOUCH: 'attr_last_touch',
        SESSION_ENTRY: 'attr_session_entry',
        CLICK_IDS: 'attr_click_ids',
        EVENT_COUNTS: 'attr_event_counts',
        LAST_EVENT: 'attr_last_event',
        RECENT_EVENTS: 'attr_recent_events',
        ANON_ID: 'attr_anon_id',
        SESSION_ID: 'attr_session_id'
    };

    const STORAGE_PREFIX = 'stellora_';
    const STATE_KEY = STORAGE_PREFIX + 'attribution_state';
    const ANON_ID_COOKIE = STORAGE_PREFIX + 'anon_id';
    const SESSION_ID_COOKIE = STORAGE_PREFIX + 'session_id';
    const SESSION_TIMEOUT_MS = 30 * 60 * 1000;
    const MAX_TOUCHPOINTS = 15;
    const MAX_SESSION_EVENTS = 25;
    const MAX_SYNC_EVENTS = 10;
    const MAX_URL_LENGTH = 180;
    const MAX_REFERRER_LENGTH = 120;
    const MAX_FIELD_LENGTH = 120;
    const CHECKOUT_SELECTOR = 'button[name="checkout"], input[name="checkout"], a[href*="/checkout"], .shopify-payment-button, .shopify-payment-button *';
    const ADD_TO_CART_SELECTOR = 'form[action*="/cart/add"] [type="submit"], button[name="add"], [data-add-to-cart], [name="add"]';
    const CLICK_ID_PARAMS = [
        'gclid', 'fbclid', 'fbc', 'fbadid', 'sub_id', '__sub_id', 'msclkid', 'ttclid', 'twclid', 'li_fat_id',
        'epik', 'pins_campaign_id', 'pin_click_id', 'pinterest_click_id',
        'sc_click_id', 'scclid', 'snap_click_id', 'snapchat_click_id'
    ];
    const LEGACY_KEYS = [
        ATTR.FIRST_SOURCE,
        ATTR.FIRST_CAMPAIGN,
        ATTR.LAST_SOURCE,
        ATTR.LAST_CAMPAIGN,
        ATTR.FULL_JOURNEY
    ];

    let lastSyncPayload = '';
    let lastSyncAtMs = 0;
    let lastEventSignature = '';
    let lastEventAtMs = 0;

    function getParam(name) {
        return new URLSearchParams(window.location.search).get(name);
    }

    function truncate(value, maxLength) {
        if (!value) return '';
        return value.length <= maxLength ? value : value.slice(0, maxLength);
    }

    function readCookie(name) {
        const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    }

    function writeCookie(name, value, maxAgeSeconds) {
        if (!value) return;
        document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAgeSeconds + '; SameSite=Lax';
    }

    function getStorageItem(key) {
        try {
            return window.localStorage.getItem(key);
        } catch (error) {
            return null;
        }
    }

    function setStorageItem(key, value) {
        try {
            window.localStorage.setItem(key, value);
        } catch (error) {
            console.error('Attribution storage write failed:', error);
        }
    }

    function safeJsonParse(value, fallbackValue) {
        if (!value) return fallbackValue;

        try {
            return JSON.parse(value);
        } catch (error) {
            return fallbackValue;
        }
    }

    function createId(label) {
        if (window.crypto && typeof window.crypto.randomUUID === 'function') {
            return STORAGE_PREFIX + label + '_' + window.crypto.randomUUID();
        }

        return STORAGE_PREFIX + label + '_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
    }

    function normalizeSource(rawSource) {
        if (!rawSource) return null;

        const source = rawSource.trim().toLowerCase();
        if (!source) return null;

        if (source === 'meta' || source === 'fb' || source === 'facebook') return 'facebook';
        if (source === 'ig' || source === 'instagram') return 'instagram';
        if (source === 'pinterestads' || source === 'pin') return 'pinterest';
        if (source === 'snap' || source === 'snapchat') return 'snapchat';
        return source;
    }

    function normalizeMedium(rawMedium, source, clickIds) {
        if (rawMedium) return rawMedium.trim().toLowerCase();
        if (clickIds.epik || clickIds.pins_campaign_id || clickIds.gclid || clickIds.fbclid || clickIds.fbc || clickIds.fbadid || clickIds.sub_id || clickIds.__sub_id || clickIds.ttclid || clickIds.msclkid || clickIds.sc_click_id || clickIds.scclid || clickIds.snap_click_id || clickIds.snapchat_click_id) return 'paid';
        if (source === 'klaviyo' || source === 'email') return 'email';
        return null;
    }

    function getReferrerDomain() {
        if (!document.referrer) return '';

        try {
            return truncate(new URL(document.referrer).hostname.toLowerCase(), MAX_REFERRER_LENGTH);
        } catch (error) {
            return truncate(document.referrer.toLowerCase(), MAX_REFERRER_LENGTH);
        }
    }

    function compactCurrentUrl() {
        return truncate(window.location.pathname + window.location.search, MAX_URL_LENGTH);
    }

    function collectClickIds() {
        const clickIds = {};

        CLICK_ID_PARAMS.forEach(function(param) {
            const value = getParam(param);
            if (value) clickIds[param] = truncate(value, MAX_FIELD_LENGTH);
        });

        return clickIds;
    }

    function inferSourceFromClickIds(clickIds) {
        const explicitSource = normalizeSource(
            getParam('utm_source') || getParam('source') || getParam('tw_source') || getParam('sub_id') || getParam('__sub_id')
        );
        if (explicitSource) return explicitSource;

        if (clickIds.epik || clickIds.pins_campaign_id || clickIds.pin_click_id || clickIds.pinterest_click_id) return 'pinterest';
        if (clickIds.fbadid || clickIds.sub_id || clickIds.__sub_id) return 'facebook';
        if (clickIds.sc_click_id || clickIds.scclid || clickIds.snap_click_id || clickIds.snapchat_click_id) return 'snapchat';
        if (clickIds.gclid) return 'google';
        if (clickIds.fbclid || clickIds.fbc) return 'facebook';
        if (clickIds.msclkid) return 'bing';
        if (clickIds.ttclid) return 'tiktok';
        if (clickIds.twclid) return 'twitter';
        if (clickIds.li_fat_id) return 'linkedin';

        const referrer = getReferrerDomain();
        if (referrer.indexOf('pinterest.com') >= 0 || referrer.indexOf('pin.it') >= 0) return 'pinterest';
        if (referrer.indexOf('snapchat.com') >= 0 || referrer.indexOf('snap.com') >= 0) return 'snapchat';
        if (referrer.indexOf('instagram.com') >= 0) return 'instagram';
        if (referrer.indexOf('facebook.com') >= 0 || referrer.indexOf('m.facebook.com') >= 0 || referrer.indexOf('l.facebook.com') >= 0 || referrer.indexOf('lm.facebook.com') >= 0) return 'facebook';

        return null;
    }

    function inferCampaign() {
        return truncate(getParam('utm_campaign') || getParam('tw_campaign') || getParam('pins_campaign_id') || '', MAX_FIELD_LENGTH);
    }

    function inferContent() {
        return truncate(getParam('utm_content') || getParam('ad_id') || getParam('creative') || '', MAX_FIELD_LENGTH);
    }

    function inferTerm() {
        return truncate(getParam('utm_term') || getParam('tw_adid') || '', MAX_FIELD_LENGTH);
    }

    function detectPageType() {
        const path = window.location.pathname.toLowerCase();

        if (path.indexOf('/products/') === 0) return 'product';
        if (path.indexOf('/collections/') === 0) return 'collection';
        if (path.indexOf('/cart') === 0) return 'cart';
        return 'page';
    }

    function createEmptyState() {
        return {
            anonId: '',
            sessionId: '',
            sessionStartedAt: '',
            sessionLastSeenAt: '',
            sessionEntry: null,
            firstTouch: null,
            lastTouch: null,
            journey: [],
            clickIds: {},
            sessionEventCounts: {},
            sessionEventLog: [],
            lastEvent: null
        };
    }

    function normalizeTouchpoint(rawTouchpoint) {
        if (!rawTouchpoint || typeof rawTouchpoint !== 'object') return null;

        return {
            t: truncate(rawTouchpoint.t || '', 40),
            s: truncate(normalizeSource(rawTouchpoint.s) || rawTouchpoint.s || '', MAX_FIELD_LENGTH),
            c: truncate(rawTouchpoint.c || '', MAX_FIELD_LENGTH),
            m: truncate(rawTouchpoint.m || '', MAX_FIELD_LENGTH),
            ct: truncate(rawTouchpoint.ct || '', MAX_FIELD_LENGTH),
            tm: truncate(rawTouchpoint.tm || '', MAX_FIELD_LENGTH),
            lp: truncate(rawTouchpoint.lp || '', MAX_URL_LENGTH),
            rd: truncate(rawTouchpoint.rd || '', MAX_REFERRER_LENGTH),
            ck: Array.isArray(rawTouchpoint.ck) ? rawTouchpoint.ck.slice(0, 8) : []
        };
    }

    function migrateLegacyState(state) {
        if (state.firstTouch || state.lastTouch || (state.journey && state.journey.length)) return state;

        const legacyFirstSource = getStorageItem(ATTR.FIRST_SOURCE);
        const legacyFirstCampaign = getStorageItem(ATTR.FIRST_CAMPAIGN);
        const legacyLastSource = getStorageItem(ATTR.LAST_SOURCE);
        const legacyLastCampaign = getStorageItem(ATTR.LAST_CAMPAIGN);
        const legacyJourney = safeJsonParse(getStorageItem(ATTR.FULL_JOURNEY), []);

        if (legacyFirstSource || legacyFirstCampaign) {
            state.firstTouch = normalizeTouchpoint({ t: '', s: legacyFirstSource || 'unknown', c: legacyFirstCampaign || 'unknown', m: '', ct: '', tm: '', lp: '', rd: '', ck: [] });
        }

        if (legacyLastSource || legacyLastCampaign) {
            state.lastTouch = normalizeTouchpoint({ t: '', s: legacyLastSource || 'unknown', c: legacyLastCampaign || 'unknown', m: '', ct: '', tm: '', lp: '', rd: '', ck: [] });
        }

        if (Array.isArray(legacyJourney)) {
            state.journey = legacyJourney.map(function(item) {
                return normalizeTouchpoint({ t: item.t || '', s: item.s || 'unknown', c: item.c || 'unknown', m: item.m || '', ct: item.ct || '', tm: item.tm || '', lp: item.lp || '', rd: item.rd || '', ck: item.ck || [] });
            }).filter(Boolean).slice(-MAX_TOUCHPOINTS);
        }

        LEGACY_KEYS.forEach(function(key) {
            try {
                window.localStorage.removeItem(key);
            } catch (error) {
                return;
            }
        });

        return state;
    }

    function loadState() {
        const state = Object.assign(createEmptyState(), safeJsonParse(getStorageItem(STATE_KEY), {}));
        return migrateLegacyState(state);
    }

    function persistState(state) {
        setStorageItem(STATE_KEY, JSON.stringify(state));

        if (state.anonId) writeCookie(ANON_ID_COOKIE, state.anonId, 60 * 60 * 24 * 365);
        if (state.sessionId) writeCookie(SESSION_ID_COOKIE, state.sessionId, Math.floor(SESSION_TIMEOUT_MS / 1000));
    }

    function ensureAnonId(state) {
        if (!state.anonId) state.anonId = readCookie(ANON_ID_COOKIE) || createId('anon');
    }

    function resetSession(state, nowIso) {
        state.sessionId = createId('session');
        state.sessionStartedAt = nowIso;
        state.sessionLastSeenAt = nowIso;
        state.sessionEntry = null;
        state.sessionEventCounts = {};
        state.sessionEventLog = [];
        state.lastEvent = null;
    }

    function ensureSession(state, now) {
        const nowMs = now.getTime();
        const lastSeenMs = state.sessionLastSeenAt ? Date.parse(state.sessionLastSeenAt) : 0;
        const sessionExpired = !state.sessionId || !lastSeenMs || (nowMs - lastSeenMs > SESSION_TIMEOUT_MS);

        if (sessionExpired) resetSession(state, now.toISOString());
        state.sessionLastSeenAt = now.toISOString();
    }

    function buildAttributionContext() {
        const clickIds = collectClickIds();
        const source = inferSourceFromClickIds(clickIds);
        const medium = normalizeMedium(getParam('utm_medium'), source, clickIds);

        return {
            source: normalizeSource(source),
            campaign: inferCampaign(),
            medium: medium || '',
            content: inferContent(),
            term: inferTerm(),
            clickIds: clickIds,
            landingPath: compactCurrentUrl(),
            referrerDomain: getReferrerDomain()
        };
    }

    function buildTouchpoint(nowIso, context) {
        return normalizeTouchpoint({
            t: nowIso,
            s: context.source || 'unknown',
            c: context.campaign || 'unknown',
            m: context.medium || '',
            ct: context.content || '',
            tm: context.term || '',
            lp: context.landingPath || '',
            rd: context.referrerDomain || '',
            ck: Object.keys(context.clickIds || {})
        });
    }

    function touchpointChanged(previousTouchpoint, nextTouchpoint) {
        if (!previousTouchpoint) return true;

        return previousTouchpoint.s !== nextTouchpoint.s || previousTouchpoint.c !== nextTouchpoint.c || previousTouchpoint.m !== nextTouchpoint.m || previousTouchpoint.ct !== nextTouchpoint.ct || previousTouchpoint.tm !== nextTouchpoint.tm;
    }

    function mergeClickIds(target, source) {
        Object.keys(source || {}).forEach(function(key) {
            if (!target[key]) target[key] = source[key];
        });
    }

    function ensureSessionEntry(state, nowIso, context) {
        if (state.sessionEntry) return;

        state.sessionEntry = {
            t: nowIso,
            u: context.landingPath,
            rd: context.referrerDomain,
            s: context.source || (context.referrerDomain ? 'referral' : 'direct'),
            c: context.campaign || '',
            m: context.medium || '',
            ck: Object.keys(context.clickIds || {})
        };
    }

    function updateAttributionState(state, context, nowIso) {
        ensureSessionEntry(state, nowIso, context);
        mergeClickIds(state.clickIds, context.clickIds || {});

        if (!context.source && !context.campaign && !context.medium && !Object.keys(context.clickIds || {}).length) return;

        const touchpoint = buildTouchpoint(nowIso, context);
        if (!state.firstTouch) state.firstTouch = touchpoint;
        state.lastTouch = touchpoint;

        const lastTouchpoint = state.journey[state.journey.length - 1];
        if (touchpointChanged(lastTouchpoint, touchpoint)) {
            state.journey.push(touchpoint);
            if (state.journey.length > MAX_TOUCHPOINTS) state.journey = state.journey.slice(-MAX_TOUCHPOINTS);
        }
    }

    function trackEvent(state, eventName, metadata) {
        const now = new Date();
        const pageType = metadata && metadata.pageType ? metadata.pageType : detectPageType();
        const signature = eventName + '|' + pageType + '|' + compactCurrentUrl();

        if (signature === lastEventSignature && now.getTime() - lastEventAtMs < 1000) return;

        lastEventSignature = signature;
        lastEventAtMs = now.getTime();
        state.sessionEventCounts[eventName] = (state.sessionEventCounts[eventName] || 0) + 1;

        const eventRecord = { t: now.toISOString(), n: eventName, p: compactCurrentUrl(), pt: pageType };
        state.lastEvent = eventRecord;
        state.sessionEventLog.push(eventRecord);
        if (state.sessionEventLog.length > MAX_SESSION_EVENTS) state.sessionEventLog = state.sessionEventLog.slice(-MAX_SESSION_EVENTS);
    }

    function hasAttributionData(state) {
        return !!(state.firstTouch || state.lastTouch || (state.journey && state.journey.length) || state.sessionEntry || (state.sessionEventLog && state.sessionEventLog.length) || state.anonId || state.sessionId);
    }

    function stringifyAttribute(value) {
        return value ? JSON.stringify(value) : '';
    }

    function buildCartAttributes(state) {
        return {
            attributes: {
                [ATTR.FIRST_SOURCE]: state.firstTouch ? state.firstTouch.s : '',
                [ATTR.FIRST_CAMPAIGN]: state.firstTouch ? state.firstTouch.c : '',
                [ATTR.LAST_SOURCE]: state.lastTouch ? state.lastTouch.s : '',
                [ATTR.LAST_CAMPAIGN]: state.lastTouch ? state.lastTouch.c : '',
                [ATTR.FULL_JOURNEY]: stringifyAttribute(state.journey || []),
                [ATTR.FIRST_TOUCH]: stringifyAttribute(state.firstTouch),
                [ATTR.LAST_TOUCH]: stringifyAttribute(state.lastTouch),
                [ATTR.SESSION_ENTRY]: stringifyAttribute(state.sessionEntry),
                [ATTR.CLICK_IDS]: stringifyAttribute(state.clickIds || {}),
                [ATTR.EVENT_COUNTS]: stringifyAttribute(state.sessionEventCounts || {}),
                [ATTR.LAST_EVENT]: stringifyAttribute(state.lastEvent),
                [ATTR.RECENT_EVENTS]: stringifyAttribute((state.sessionEventLog || []).slice(-MAX_SYNC_EVENTS)),
                [ATTR.ANON_ID]: state.anonId || '',
                [ATTR.SESSION_ID]: state.sessionId || ''
            }
        };
    }

    function injectAttributionToCart(state, force) {
        if (!hasAttributionData(state)) return;

        const cartAttributes = buildCartAttributes(state);
        const payload = JSON.stringify(cartAttributes);
        const nowMs = Date.now();

        if (payload === lastSyncPayload && !force) return; // identical attributes already on the cart: never rewrite
        if (!force && nowMs - lastSyncAtMs < 15000) return; // throttle periodic syncs (was 3s; each write costs a cart round-trip + drawer refresh)
        if (force && payload === lastSyncPayload && nowMs - lastSyncAtMs < 2000) return; // collapse duplicate force flushes

        lastSyncPayload = payload;
        lastSyncAtMs = nowMs;

        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: payload,
            keepalive: true
        }).catch(function(error) {
            console.error('Attribution sync failed:', error);
        });
    }

    function isCheckoutIntent(target) {
        if (!target || !(target instanceof Element)) return false;
        return !!target.closest(CHECKOUT_SELECTOR);
    }

    function isAddToCartIntent(target) {
        if (!target || !(target instanceof Element)) return false;
        return !!target.closest(ADD_TO_CART_SELECTOR);
    }

    function initializeState() {
        const state = loadState();
        const now = new Date();
        const nowIso = now.toISOString();
        const context = buildAttributionContext();

        ensureAnonId(state);
        ensureSession(state, now);
        updateAttributionState(state, context, nowIso);
        persistState(state);

        return state;
    }

    document.addEventListener('DOMContentLoaded', function() {
        const state = initializeState();
        const pageType = detectPageType();

        trackEvent(state, 'page_view', { pageType: pageType });
        if (pageType === 'product') trackEvent(state, 'product_view', { pageType: pageType });
        if (pageType === 'collection') trackEvent(state, 'collection_view', { pageType: pageType });
        if (pageType === 'cart') trackEvent(state, 'cart_view', { pageType: pageType });

        persistState(state);
        injectAttributionToCart(state, false);

        document.addEventListener('click', function(event) {
            let changed = false;

            if (isAddToCartIntent(event.target)) {
                trackEvent(state, 'add_to_cart', { pageType: detectPageType() });
                changed = true;
            }

            if (isCheckoutIntent(event.target)) {
                trackEvent(state, 'begin_checkout', { pageType: detectPageType() });
                changed = true;
            }

            if (changed) {
                persistState(state);
                injectAttributionToCart(state, true);
            }
        }, true);

        document.addEventListener('submit', function(event) {
            if (isAddToCartIntent(event.target) || isCheckoutIntent(event.target)) return;

            injectAttributionToCart(state, false);
        }, true);

        document.addEventListener('visibilitychange', function() {
            if (document.visibilityState === 'hidden') {
                persistState(state);
                injectAttributionToCart(state, true);
            }
        });

        window.addEventListener('pagehide', function() {
            persistState(state);
            injectAttributionToCart(state, true);
        });

        window.setTimeout(function() {
            persistState(state);
            injectAttributionToCart(state, false);
        }, 1500);
    });
})();